// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Button_wrapper_23OCs","bordered":"Button_bordered_29945"};